import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError, finalize } from 'rxjs/operators';
import { DenounceOperator, DenounceRole } from '../interfaces/denounce.interface';

@Injectable({
  providedIn: 'root',
})
export class DenounceAccessService {
  private apiUrl = `${environment.apiNest}denounces/access`;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  constructor(private http: HttpClient) {}

  private handleError(error: HttpErrorResponse) {
    let customError: any = {
      statusCode: error.status,
      message: 'Ha ocurrido un error',
      ...error.error,
    };
    if (error.status === 403) {
      customError.message = 'No tiene permisos para esta acción.';
    }
    return throwError(() => customError);
  }

  listOperators(): Observable<DenounceOperator[]> {
    this.loadingSubject.next(true);
    return this.http.get<DenounceOperator[]>(`${this.apiUrl}/operators`).pipe(
      catchError(this.handleError),
      finalize(() => this.loadingSubject.next(false)),
    );
  }

  addOperator(data: {
    email: string;
    role: DenounceRole;
  }): Observable<DenounceOperator> {
    this.loadingSubject.next(true);
    return this.http.post<DenounceOperator>(`${this.apiUrl}/operators`, data).pipe(
      catchError(this.handleError),
      finalize(() => this.loadingSubject.next(false)),
    );
  }

  updateRole(id: string, role: DenounceRole): Observable<any> {
    this.loadingSubject.next(true);
    return this.http.put<any>(`${this.apiUrl}/operators/${id}`, { role }).pipe(
      catchError(this.handleError),
      finalize(() => this.loadingSubject.next(false)),
    );
  }

  revokeAccess(id: string): Observable<any> {
    this.loadingSubject.next(true);
    return this.http.delete<any>(`${this.apiUrl}/operators/${id}`).pipe(
      catchError(this.handleError),
      finalize(() => this.loadingSubject.next(false)),
    );
  }
}
